/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * OpenAPI spec version: 1.0.0
 */

export type ContractDtoPaymentStatus = typeof ContractDtoPaymentStatus[keyof typeof ContractDtoPaymentStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractDtoPaymentStatus = {
  Sold: 'Sold',
  Adjusted: 'Adjusted',
  Partial: 'Partial',
  PaidInFull: 'PaidInFull',
} as const;
